import { useCallback, useContext } from 'react';
import { AppContext } from '../../context/AppContext/context';

const useSubscriptionModal = () => {
  const {
    state: { isSubModalDismissed },
    dispatch,
  } = useContext(AppContext);

  const openSubscriptionModal = useCallback(() => {
    dispatch({
      type: 'SET_SUB_MODAL_DISMISSED',
      payload: false,
    });
  }, [dispatch]);

  const closeSubscriptionModal = useCallback(() => {
    dispatch({
      type: 'SET_SUB_MODAL_DISMISSED',
      payload: true,
    });
  }, [dispatch]);

  return {
    dismissed: isSubModalDismissed,
    openSubscriptionModal,
    closeSubscriptionModal,
  };
};

export default useSubscriptionModal;
